import React, { FC } from 'react'
import { IconProps, SIZES } from '../exports'

/* Styles ======================================================================================== */
import { DownloadStyled } from './download.styled'

const Download: FC<IconProps> = props => {
  const { size = 'md', isAnimated, color, ...others } = props
  const theme = {
    color: `${color ? color : 'currentColor'}`,
  }
  return (
    <DownloadStyled
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={isAnimated !== undefined ? 'is-animated' : ''}
      theme={theme.color}
      {...SIZES[size]}
      {...others}
    >
      <path
        d="M7 21H2V29H6M25 21H30V29H12"
        className="stroke draw-stroke-path stroke-path-1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14.3194L15.9759 24L24 14.3194H19.0809L19.0809 3L12.9191 3L12.9191 14.3194L8 14.3194Z"
        className="stroke stroke-path-2"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </DownloadStyled>
  )
}

export default Download
